import { Component, inject, model, viewChild } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';

import { ModalService } from '../../../services';
import { BaseFormComponent } from '../../base-form/base-form.component';
import { SummaryTopComponent } from '../../summary-top/summary-top.component';

@Component({
  selector: 'app-form-ok-cancel-modal',
  templateUrl: './form-ok-cancel-modal.component.html',
  styleUrl: './form-ok-cancel-modal.component.scss',
  imports: [SummaryTopComponent, BaseFormComponent],
})
export class FormOkCancelModalComponent {
  private readonly modalService = inject(ModalService);

  public readonly form = viewChild(BaseFormComponent);

  public readonly header = model<string>();
  public readonly message = model<string>();
  public readonly fields = model<FormlyFieldConfig[]>();
  public readonly okLabel = model($localize`Ok`);
  public readonly model = model<any>({});

  onOk() {
    if (this.form() && !this.form().validate()) {
      return;
    }
    this.modalService.close(this.model());
  }

  onCancel() {
    this.modalService.dismiss();
  }
}
